import React, { Component } from "react";
import { connect } from "react-redux";
import {
  fetchBeneficiaries,
  fetchUpdateBeneficiaries
} from "../../actions/BeneficiaryActions";
import InputMask from "react-input-mask";
import DayPickerInput from "react-day-picker/DayPickerInput";
import {FaAngleDoubleRight, FaAngleDoubleLeft, FaTrashAlt } from "react-icons/fa";
import {TiUserAddOutline, TiUserDeleteOutline } from "react-icons/ti";
import { stepNumberHelper } from "../../utils/StepNumberHelper";
import { fetchUpdatePackageProgress } from "../../actions/EnrollmentActions";
import { withRouter } from "react-router-dom";
import { ContentCard } from "../Cards";

import {
  formatDate,
  parseDate,
} from 'react-day-picker/moment';

import "react-day-picker/lib/style.css";
import "./BeneficiariesEditor.scss";

class BeneficiariesEditor extends Component {
  state = {
    beneficiaries: []
  };

  async componentDidMount() {
    await this.fetchBeneficiaries();
  }

  fetchBeneficiaries = async () => {
    const { policyId } = this.props.match.params;
    const { packageId } = this.props;

    await this.props.fetchBeneficiaries(policyId, packageId);

    this.setState({
      beneficiaries: this.props.beneficiaries.data
    });

  };

  updateBeneficiaryData = (e, key, field) => {
    const { beneficiaries } = this.state;

    beneficiaries[key][field] = field !== "dateOfBirth" ? e.target.value : e;

    this.setState({
      beneficiaries: beneficiaries
    });
  };

  validateAndSubmit = async () => {
    //validate percentages
    let valid = true;
    const beneficiaries = this.state.beneficiaries;

    if(beneficiaries.filter(b => b.isPrimary).length === 0){
      alert("Must have at least one primary beneficiary");
      valid = false;
    }

    const totalPrimaryPercentage = beneficiaries.reduce((acc, curVal) => {
      return curVal.isPrimary && curVal.percentage ? acc + parseFloat(curVal.percentage) : acc;
    }, 0);

    // toFixed returns a string. The "+" is a JavaScript way of getting it back to a number.
    const primaryPercentageRounded = +totalPrimaryPercentage.toFixed(3);

    if (primaryPercentageRounded !== 100) {
      alert("Primary Percentage must add up to 100%");
      valid = false;
    }

    const totalContingentPercentage = beneficiaries.reduce((acc, curVal) => {
      return !curVal.isPrimary && curVal.percentage ? acc + parseFloat(curVal.percentage) : acc;
    }, 0);

      // toFixed returns a string. The "+" is a JavaScript way of getting it back to a number.
    const contingentPercentageRounded = +totalContingentPercentage.toFixed(3);

    if (contingentPercentageRounded !== 100 && beneficiaries.filter(b => !b.isPrimary).length > 0) {
      alert("Contingent Percentage must add up to 100%");
      valid = false;
    }

    //validate entries are not null
      beneficiaries.forEach((b) => {
          if (typeof b.dependentPersonId !== "number") {
              // only validate new rows missing the dependentPersonId info
              if (!b.name) {
                  alert("Name field required when adding a beneficiary");
                  valid = false;
              }

              if(!b.relationship ){
                alert("Relationship field required when adding a beneficiary");
                valid = false;
              }
          }
      });

    if (valid) {
      const { policyId } = this.props.match.params;
      const { packageId } = this.props;

      await this.props.fetchUpdateBeneficiaries(
        policyId,
        packageId,
        this.state.beneficiaries);

      await this.onPageForward();
    }
  };

  addNewRow = isPrimary => {
    let beneficiaries = this.state.beneficiaries;
    beneficiaries.push({
      id: null,
      name: "",
      relationship: "",
      usSocialSecurityNumber: "",
      dateOfBirth: "",
      percentage: "",
      dependentPersonId: null,
      isPrimary: isPrimary
    });
    this.setState({
      beneficiaries: beneficiaries
    });
  };

  makeContingent = key => {
    const beneficiaries = this.state.beneficiaries;
    beneficiaries[key].isPrimary = false;
    this.setState({
      beneficiaries
    });
  };

  makePrimary = key => {
    const beneficiaries = this.state.beneficiaries;
    beneficiaries[key].isPrimary = true;
    this.setState({
      beneficiaries
    });
  };

  deleteRow = key => {
    const delConfirm = this.props.message
      ? window.confirm(this.props.message)
      : window.confirm("Are you sure you want to delete this?");
    if (delConfirm) {
      let beneficiaries = this.state.beneficiaries;
      beneficiaries.splice(key, 1);
      this.setState({
        beneficiaries: beneficiaries
      });
    }
  };

  togglePrimaries = () => {
    let expandPrimaries = this.state.expandPrimaries;
    expandPrimaries = !expandPrimaries;
    this.setState({
      expandPrimaries
    });
  };

  toggleContingent = () => {
    let expandContingent = this.state.expandContingent;
    expandContingent = !expandContingent;
    this.setState({
      expandContingent
    });
  };

  onPageBack = () => {
    this.props.history.goBack();
  };

  async onPageForward() {
    const activePackage = this.props.activePackage.data;
    const packageId = this.props.packageId;
    const planTypeId = parseInt(this.props.match.params.planTypeId, 10);
    const currentStepNumber = stepNumberHelper.stepNumberForPlanTypeStep(
      activePackage,
      planTypeId
    );

    const updatePackageResults = await this.props.fetchUpdatePackageProgress(packageId, currentStepNumber, true);
    
    const nextStepRoute = this.getNextStepRoute(updatePackageResults, planTypeId);
    this.props.history.push(nextStepRoute);
  }

  getNextStepRoute = (activePackage, planTypeId) => {
    const nextStep = this.getNextStep(activePackage, planTypeId, 1);
    if (nextStep) {
      if (nextStep.type === "PlanType" && nextStep.relatedEntityId) {
        if(nextStep.harmonyProductGroup) {
          return '/packages/' + activePackage.enrollmentPackageId + '/harmony/' + nextStep.harmonyProductGroup;
        } else {
          return '/packages/' + activePackage.enrollmentPackageId + '/plantypes/' + nextStep.relatedEntityId;
        }
      } else {
        if (nextStep.type === "Insurability") {
          return (
            "/packages/" + activePackage.enrollmentPackageId + "/insurability"
          );
        } else {
          return "/packages/" + activePackage.enrollmentPackageId + "/summary";
        }
      }
    } else {
      // if cannot determine next step, return current step
      return (
        "/packages/" +
        activePackage.enrollmentPackageId +
        "/plantypes/" +
        planTypeId
      );
    }
  };

  getNextStep = (activePackage, planTypeId, direction) => {
    if (activePackage.steps) {
      for (let i = 0; i < activePackage.steps.length; i++) {
        if (
          activePackage.steps[i].type === "PlanType" &&
          activePackage.steps[i].relatedEntityId === planTypeId
        ) {
          return activePackage.steps[i + direction];
        }
      }
    }
    return null;
  };

  render() {
    const beneficiaries = this.state.beneficiaries;
    const loading = this.props.beneficiaries.loading;

    return (
      <ContentCard loading={loading}>
        <h2>Beneficiaries</h2>
        <p>
          Please enter the Beneficiary Information for this policy. You must
          have at least one Primary Beneficiary.
        </p>

        <div className="mb-4">
          <h2>Primary Beneficiaries</h2>
          <React.Fragment>
            <table className="table table-striped beneficiaries-table">
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Relationship</th>
                  <th>SSN</th>
                  <th>Birthdate</th>
                  <th>Percentage</th>
                  <th />
                </tr>
              </thead>
              <tbody>
                {beneficiaries.map((b, key) => (
                  <React.Fragment key={`pb-${key}`}>
                    {b.isPrimary && (
                      <tr>
                        <td>
                          <input
                            type="text"
                            className="form-control"
                            value={b.name}
                            readOnly={
                              b.dependentPersonId && b.dependentPersonId > 0
                            }
                            onChange={e =>
                              this.updateBeneficiaryData(e, key, "name")
                            }
                          />
                        </td>
                        <td>
                          <input
                            type="text"
                            className="form-control"
                            readOnly={
                              b.dependentPersonId && b.dependentPersonId > 0
                            }
                            value={b.relationship}
                            onChange={e =>
                              this.updateBeneficiaryData(
                                e,
                                key,
                                "relationship"
                              )
                            }
                          />
                        </td>
                        <td>
                          <InputMask
                            className="form-control"
                            mask="999-99-9999"
                            readOnly={
                              b.dependentPersonId && b.dependentPersonId > 0
                            }
                            value={b.usSocialSecurityNumber}
                            onChange={e =>
                              this.updateBeneficiaryData(
                                e,
                                key,
                                "usSocialSecurityNumber"
                              )
                            }
                          />
                        </td>
                        <td className="dp-input">
                          {b.dependentPersonId && b.dependentPersonId > 0 ? (
                            <input
                              type="text"
                              className="form-control"
                              value={b.dateOfBirth}
                              readOnly={true}
                            />
                          ) : (
                            <DayPickerInput
                              value={b.dateOfBirth}
                              className="form-control"
                              formatDate={formatDate}
                              parseDate={parseDate}
                              placeholder={"MM/DD/YYYY"}
                              disabled={
                                b.dependentPersonId && b.dependentPersonId > 0
                              }
                              onDayChange={day =>
                                this.updateBeneficiaryData(
                                  day,
                                  key,
                                  "dateOfBirth"
                                )
                              }
                            />
                          )}
                        </td>
                        <td>
                          <input
                            type="text"
                            className="form-control"
                            value={b.percentage}
                            style={{ width: "75%", display: "inline-block" }}
                            onChange={e =>
                              this.updateBeneficiaryData(e, key, "percentage")
                            }
                          />{" "}
                          %
                        </td>
                        <td>
                          <div className="btn-group" role="group">
                            <button
                              type="button"
                              className="btn btn-sm btn-outline-primary"
                              onClick={() => this.makeContingent(key)}
                            >
                              <TiUserDeleteOutline />
                            </button>

                            <button
                              type="button"
                              className="btn btn-sm btn-outline-danger"
                              onClick={() => this.deleteRow(key)}
                            >
                              <FaTrashAlt />
                            </button>
                          </div>
                        </td>
                      </tr>
                    )}
                  </React.Fragment>
                ))}
              </tbody>
            </table>
            <div>
              <button
                type="button"
                className="btn btn-primary"
                onClick={() => this.addNewRow(true)}
              >
                Add Row
              </button>
            </div>
          </React.Fragment>
        </div>

        <div className="mb-4">
          <h2>Contingent Beneficiaries</h2>
          <React.Fragment>
            <table className="table table-striped beneficiaries-table">
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Relationship</th>
                  <th>SSN</th>
                  <th>Birthdate</th>
                  <th>Percentage</th>
                  <th />
                </tr>
              </thead>
              <tbody>
                {beneficiaries.map((b, key) => (
                  <React.Fragment key={`cb-${key}`}>
                    {!b.isPrimary && (
                      <tr>
                        <td>
                          <input
                            type="text"
                            className="form-control"
                            value={b.name}
                            readOnly={
                              b.dependentPersonId && b.dependentPersonId > 0
                            }
                            onChange={e =>
                              this.updateBeneficiaryData(e, key, "name")
                            }
                          />
                        </td>
                        <td>
                          <input
                            type="text"
                            className="form-control"
                            readOnly={
                              b.dependentPersonId && b.dependentPersonId > 0
                            }
                            value={b.relationship}
                            onChange={e =>
                              this.updateBeneficiaryData(
                                e,
                                key,
                                "relationship"
                              )
                            }
                          />
                        </td>
                        <td>
                          <InputMask
                            className="form-control"
                            mask="999-99-9999"
                            readOnly={
                              b.dependentPersonId && b.dependentPersonId > 0
                            }
                            value={b.usSocialSecurityNumber}
                            onChange={e =>
                              this.updateBeneficiaryData(
                                e,
                                key,
                                "usSocialSecurityNumber"
                              )
                            }
                          />
                        </td>
                        <td className="dp-input">
                          {b.dependentPersonId && b.dependentPersonId > 0 ? (
                            <input
                              type="text"
                              className="form-control"
                              value={b.dateOfBirth}
                              readOnly={true}
                            />
                          ) : (
                            <DayPickerInput
                              value={b.dateOfBirth}
                              className="form-control"
                              formatDate={formatDate}
                              parseDate={parseDate}
                              placeholder={"MM/DD/YYYY"}
                              disabled={
                                b.dependentPersonId && b.dependentPersonId > 0
                              }
                              onDayChange={day =>
                                this.updateBeneficiaryData(
                                  day,
                                  key,
                                  "dateOfBirth"
                                )
                              }
                            />
                          )}
                        </td>
                        <td>
                          <input
                            type="text"
                            className="form-control"
                            value={b.percentage}
                            style={{ width: "75%", display: "inline-block" }}
                            onChange={e =>
                              this.updateBeneficiaryData(e, key, "percentage")
                            }
                          />{" "}
                          %
                        </td>
                        <td>
                          <div className="btn-group" role="group">
                            <button
                              type="button"
                              className="btn btn-sm btn-outline-primary"
                              onClick={() => this.makePrimary(key)}
                            >
                              <TiUserAddOutline />
                            </button>
                            <button
                              type="button"
                              className="btn btn-sm btn-outline-danger"
                              onClick={() => this.deleteRow(key)}
                            >
                              <FaTrashAlt />
                            </button>
                          </div>
                        </td>
                      </tr>
                    )}
                  </React.Fragment>
                ))}
              </tbody>
            </table>
            <div>
              <p><strong>If all primary beneficiaries are disqualified or die before me, I select these contingent beneficiaries.</strong></p>
              <button
                type="button"
                className="btn btn-primary"
                onClick={() => this.addNewRow(false)}
              >
                Add Row
              </button>
            </div>
          </React.Fragment>
        </div>

        <div className="mt-4 d-flex justify-content-between">
          <button
            className="btn btn-default"
            type="button"
            onClick={e => this.onPageBack()}
          >
            <FaAngleDoubleLeft /> Back
          </button>
          <button
            type="button"
            className="btn btn-primary"
            onClick={() => this.validateAndSubmit()}
            disabled={this.props.activePackage.loading}
          >
            Save &amp; Continue <FaAngleDoubleRight />
          </button>
        </div>
      </ContentCard>
    );
  }
}

const mapStateToProps = state => {
  return {
    beneficiaries: state.beneficiaries.personBeneficiaries,
    activePackage: state.packages.activePackage
  };
};

const mapDispatchToProps = dispatch => {
  return {
      fetchBeneficiaries: (policyId, packageId) => {
          return dispatch(fetchBeneficiaries(policyId, packageId));
      },
      fetchUpdateBeneficiaries: (policyId, packageId, beneficiaries) => {
          return dispatch(fetchUpdateBeneficiaries(policyId, packageId, beneficiaries));
      },
      fetchUpdatePackageProgress: (packageId, stepNumber, updateSteps) => {
          return dispatch(fetchUpdatePackageProgress(packageId, stepNumber, updateSteps));
      }
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(BeneficiariesEditor));
